( function( $ ) {
	$( document ).ready( function() {
		const vimeoIframes = document.getElementsByClassName( 'vimeo-player' );
		const videoIframes = document.getElementsByClassName( 'youtube-player' );
		let functionalCookieActive = false;

		if( document.cookie.split( '; ' ).find( ( row ) => row.startsWith( 'OptanonConsent=' ) ) != undefined ) {
			functionalCookieActive = document.cookie.split( '; ' ).find( ( row ) => row.startsWith( 'OptanonConsent=' ) ).includes( 'C0003%3A1' );
		}
		// for vimeo videos
		for ( var i = 0; i < vimeoIframes.length; i++ ) {
			const currentVideo = vimeoIframes.item( i );
			const currentURL = currentVideo.dataset.src;

			if( functionalCookieActive === true ) {
				currentVideo.src = currentURL;
			} else {
				if( currentURL.includes( '?' ) === true ) {
					currentVideo.src = currentURL + '&dnt=true';
				} else {
					currentVideo.src = currentURL + '?dnt=true';
				}
			}
		}

		// for youtube videos
		// using j letter to avoid double use i in same function
		for (let j = 0; j < videoIframes.length; j++) {
			const currentVideo = videoIframes.item(j);
			let currentURL = currentVideo.dataset.src;

			if (functionalCookieActive === true) {
				currentURL = currentURL.replace(/youtube(-nocookie)?\.com/g, 'youtube-nocookie.com');
			}
			// Set the updated URL to the video's src attribute
			currentVideo.src = currentURL;
		}

		// Stop and reload Vimeo player on modal close.
		$('.modal').on('hidden.bs.modal', function() {
			const vimeoIframe = $(this).find('.vimeo-player');
			const src = vimeoIframe.attr('data-src');
			vimeoIframe.attr('src', '');
			vimeoIframe.attr('src', src);

			const videoIframe = $(this).find('.youtube-player');
			const videoSrc = videoIframe.attr('data-src');
			videoIframe.attr('src', '');
			videoIframe.attr('src', videoSrc);
		});
	} );
} )( jQuery );